var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.342,
    height: 13.826,
    viewBox: "0 0 10.342 13.826",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#208ce1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.342,5.168A5.184,5.184,0,0,0,5.366,0L5.3,0H5.235L5.168,0H5.035L4.97,0A5.176,5.176,0,0,0,0,5.168q0,.09,0,.18t0,.193A5.839,5.839,0,0,0,.092,6.582c0,.02.014.081.035.185A5.727,5.727,0,0,0,.473,7.86a15.421,15.421,0,0,0,4.468,5.879.347.347,0,0,0,.46,0A15.448,15.448,0,0,0,9.869,7.86a5.667,5.667,0,0,0,.346-1.093c.022-.1.032-.165.035-.185a6.1,6.1,0,0,0,.092-1.041c0-.065,0-.129,0-.194S10.342,5.228,10.342,5.168Zm-2.629.239a2.551,2.551,0,0,1-5.09,0q-.007-.091-.007-.182a2.552,2.552,0,0,1,5.1,0Q7.72,5.317,7.713,5.407Z",
    transform: "translate(0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.1664d48a159d7bbe38af9eedeb83ad2e.svg";
export { ForwardRef as ReactComponent };